// Pemilih avatar untuk ujian prompt Partner — pilihan SAMA Workspace (App.jsx handleHeaderAddProduct):
//   'none'      → tiada avatar, tiada jantina          → Mode 1
//   '__male__'  → Default (M): jantina sahaja          → Mode 2
//   '__female__'→ Default (F): jantina sahaja          → Mode 2
//   <id>        → avatar simpanan users/{uid}/avatars  → Mode 3 (jantina ikut avatar)
// ⚠️ KEMBAR peraturan mod = determineMasterPromptMode (functions/index.js) + App.jsx isGenderOnly.
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase';

export const AVATAR_TETAP = [
    { id: 'none', nama: 'No avatar', mode: 1, gender: null },
    { id: '__male__', nama: 'Default (M)', mode: 2, gender: 'male' },
    { id: '__female__', nama: 'Default (F)', mode: 2, gender: 'female' },
];

const labelSimpanan = (a) => {
    const bits = [a.name || 'Avatar'];
    if (a.gender) bits.push(a.gender === 'male' ? 'male' : 'female');
    if (a.age) bits.push(a.age);
    if (a.gender === 'female' && typeof a.hijab === 'boolean') bits.push(a.hijab ? 'hijab' : 'no hijab');
    return bits.join(' · ');
};

export function useAvatarLab() {
    const [simpanan, setSimpanan] = useState({ senarai: [], dimuat: false, ralat: '' });
    useEffect(() => {
        let batal = false;
        (async () => {
            const uid = auth.currentUser?.uid;
            let senarai = []; let ralat = '';
            try {
                if (uid) {
                    const s = await getDocs(collection(db, 'users', uid, 'avatars'));
                    senarai = s.docs.map((d) => ({ id: d.id, ...d.data() }))
                        .sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0));
                }
            } catch (e) { ralat = `Could not load your avatars: ${e.message}`; }
            if (!batal) setSimpanan({ senarai, dimuat: true, ralat });
        })();
        return () => { batal = true; };
    }, []);
    const pilihan = [
        ...AVATAR_TETAP,
        ...simpanan.senarai.map((a) => ({ id: a.id, nama: labelSimpanan(a), mode: 3, gender: a.gender || null, avatar: a })),
    ];
    return { pilihan, dimuat: simpanan.dimuat, ralat: simpanan.ralat, bilSimpanan: simpanan.senarai.length };
}

/** Avatar → medan yang server baca (id, umur, tudung). Gambar avatar TIDAK dihantar. */
export const avatarUntukServer = (p) => (p?.mode === 3 && p.avatar
    ? { id: p.avatar.id, age: p.avatar.age || '', hijab: typeof p.avatar.hijab === 'boolean' ? p.avatar.hijab : null }
    : null);
